// eslint-disable-next-line
/* eslint-disable */
import axios from 'axios';
import store from '../store/index.js'

let token = '';
 
const urls = 'https://web-api.chuangyou56.com' 
  
// const urls = 'http://192.168.1.9:8062'   
 
// const urls = 'http://192.168.1.5:8062' 

// const urls = "http://localhost:8062"; 
 
axios.defaults.headers.common['token'] = token;  

axios.defaults.timeout = 600000; 

//地址:端口  
export function getUrls() { 
	return urls;  
};  
    
//图片上传 
export function uploadFiles() {
	// return "http://192.168.1.11:8062/api/file/uploadFile";
	return "https://web-api.chuangyou56.com/api/file/uploadFile";
};
   
//图片上传
export function uploadFile() {
	// return "http://192.168.1.11:8062/api/file/uploadFile";
	return "https://web-api.chuangyou56.com/api/file/uploadFile";
};
//请求拦截器
axios.interceptors.request.use(function(config) {
	let user = window.sessionStorage.getItem('token');
	if (user) {
		token = user;
	}
	else{
	 
	}
	config.headers.common['token'] = token;
	return config;
}, function(error) { 
	console.info(error);
	return Promise.reject(error);
});

//响应拦截
axios.interceptors.response.use(function(response) {
	if (response.data && response.data.state == 'need_login') { //登录过期
		// console.log(response)
		window.sessionStorage.removeItem('token')
		window.localStorage.removeItem('vuex')
		location.href = '/'
	}
	return response;
}, function(error) {
	console.dir(error);
	return Promise.reject(error);
})


/*
  封装图片上传
*/
export function upload(url, data) {
	return new Promise((resolve, reject) => {
		axios.post(uploadFile() + url, data, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios.get(urls + url, {
				params: params
			})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}

export function toExcel(url, param) {
	return axios.request({
		url: urls + url, //完整路由地址
		method: 'post', //请求类型
		data: param,
		procgress: true,
		responseType: 'blob' //响应类型，避免乱码
	})
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.post(urls + url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.put(urls + url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function del(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios.delete(urls + url, {
				params: params
			})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}
